<template>
  <div class="page-wrap">
    <div class="video-wrap">
      <div id="player-con" v-show="showVideo"></div>
      <div class="video-bg"
        :style="videoBg"
        v-show="!showVideo">
        <div class="video-text-wrap">
          <div class="video-text">给人才发展的舞台</div>
          <div class="video-play-btn"
            :style="videoPlayBtn"
            @click="play"></div>
        </div>
      </div>
    </div>
    <div style="background: #f2f2f2;">
      <div class="dynamic-wrap">
        <div class="dynamic-title">招聘动态：</div>
        <div class="dynamic-content">
          <transition name="dynamic-list" mode="out-in">
            <template v-for="(item, index) in dynamicList">
              <span :key="index" v-if="index==dynamicIndex">
                {{item.text}}
                <span class="dynamic-more" @click.stop="$router.push('/News/'+item.value)">更多</span>
              </span>
            </template>
          </transition>
        </div>
      </div>
    </div>
    <div class="nav-wrap">
      <div class="nav-item">
        <div class="nav-img-wrap" @click="applyJob">
          <img class="nav-img" src="../../assets/img/home/wangc.png" alt />
        </div>
        <div class="nav-text">网测</div>
      </div>
      <div class="nav-item" v-for="(item, index) in navList" :key="index">
        <router-link :to="item.url" class="nav-img-wrap" tag="div">
          <img class="nav-img" :src="item.src" alt />
        </router-link>
        <div class="nav-text">{{item.text}}</div>
      </div>
    </div>
    
    <div class="xiai">
      <div class="title-wrap">
        <div class="item-title">员工喜爱的文化</div>
      </div>
      <div class="swiper-container" id="xiai">
        <div class="swiper-wrapper tiyan-swiper">
          <div class="swiper-slide tiyan_item" v-for="(item, index) in xiaiList" :key="index">
            <div class="tiyan_content">
              <img :src="item">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="characteristic gap" style="margin-top: 1.5rem;">
      <div class="title-wrap">
        <div class="item-title">特色机制</div>
      </div>
      <div class="characteristic-wrap">
        <div class="default-box" :style="defaultBox"></div>
        <div class="swiper-container characteristic-swiper-container">
          <div class="swiper-wrapper characteristic-swiper">
            <div
              class="swiper-slide characteristic-swiper-slide"
              v-for="(item, index) in characteristicList"
              :key="index"
            >
              <div class="characteristic-img" :style="{background: 'url(' + item.url + ') no-repeat'}"></div>
              <div class="characteristic-box">
                <div class="c-title">{{item.title}}</div>
                <div class="c-banner">{{item.content}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wed-doing gap">
      <div class="title-wrap">
        <div class="item-title">我们做的事</div>
      </div>
      <div class="swiper-container wed-doing-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide wed-doing-slide" v-for="(item, index) in doingList" :key="index" :val="item.value">
            <div class="we-doing-box">
              <div
                class="we-doing-bg"
                :style="{background: 'url(' + item.url + ')no-repeat center/cover'}"
              ></div>
              <div class="we-doing-text">
                <div>{{item.content}}</div>
                <div>了解更多</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="gap">
      <div class="title-wrap">
        <div class="item-title">企业成就</div>
      </div>
      <div class="achievement" 
        :style="achievementBg"
        @click.stop="$router.push('/Company')">
        <div class="concept">我们服务于证券行业，我们是期货软件一哥，我们的客户遍布全国各地</div>
        <div class="data-detail">
          <div class="data" v-for="(item, index) in achievementList" :key="index">
            <div class="numeric">
              <span>{{item.num}}</span>
              <span>{{item.unit}}</span>
            </div>
            <div class="type">{{item.type}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="gap" style="margin-top: 2.734rem;">
      <div class="title-wrap">
        <div class="item-title">来了就不想走的地方</div>
      </div>
      <div class="concept good-place" :style="goodPlaceBg">
        <p>
          我们具有{{ $store.state.commonData.companyAge }}年历史，多年来稳定发展。我们不是国企，但是也一样有实力为员工提供长期稳定的工作机会。
        </p>
        <p>
          在文华工作10年以上的员工占公司总人数近三分之一；校招加入文华的在职员工，有半数以上已经在文华工作超过5年了...
        </p>
      </div>
    </div>
    <div class="gap">
      <div class="title-wrap">
        <div class="item-title">文华用人观</div>
      </div>
      <div class="concept">
        <div>企业发展的根本是“用一流的待遇吸纳一流的人才”</div>
        <div>公司想运营得好必须有充足的人才，我们想做的事要有充足的人才去实现，这是企业发展的根本。怎么保证人才充足？—— 就是“用一流的待遇吸纳一流的人才”。</div>
        <div>发展这么多年，我们的平均薪资在行业内一直很高，所以一直能够让我们维持人员的充足率。现在我们的薪资更高，这让我们能够拥有更高的人员充足率来满足我们更大的发展。以后还要继续在薪资上追求突破，一流的公司和一流的待遇是一直联系在一起的。</div>
        <div class="name">——创始人尚守哲</div>
      </div>
    </div>

    <div class="gap">
      <div class="title-wrap">
        <div class="item-title">工作体验</div>
      </div>
      <div class="swiper-container" id="tiyan" ref="tiyan">
        <div class="swiper-wrapper tiyan-swiper">
          <div class="swiper-slide tiyan_item" v-for="(item, index) in list" :key="index">
            <div class="tiyan_item_header">
              <div class="tiyan_icon" :style="{background: 'url(' + item.img_h + ') no-repeat center/cover'}"></div>
              <div class="tiyan_name">{{ item.name }}</div>
            </div>
            <div class="tiyan_content">
              <img :src="item.img_c">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-bg" :style="bottomBg"></div>
    <NetTest v-if="show" :url="netUrl" :step="step" :jobs="jobList" fromPage="main" @closeDialog="closeDialog"></NetTest>
   <bottom style="flex: 0 0 2.2rem;"></bottom>
  </div>
</template>

<script>
import Swiper from "swiper/dist/js/swiper.min.js";
import NetTest from "./NetTest";
import Bottom from "../Bottom";
const baseUrl = process.env.BASE_URL;

export default {
  components: {
    NetTest,
    Bottom,
  },
  data() {
    // 工作体验数据
    let list = [
      "开发一部 chichi",
      "研究一部 豆芽",
      "研究一部 羊羊",
      "研究一部 小渔",
      "研究一部 爱吃猫的鱼",
      "开发一部 Minina",
      "开发二部 Ray",
      "研究二部 风驻亭",
      "开发四部 过客",
      "研究一部 闪闪",
    ].map((item, index) => {
      let No = index + 1;
      return {
        name: item,
        img_h: `${baseUrl}ImgFiles/home/gzty/${(No < 10 ? ('0' + No) : No)}/h.png`,
        img_c: `${baseUrl}ImgFiles/home/gzty/${(No < 10 ? ('0' + No) : No)}/c.png`,
      }
    });
    return {
      videoBg: `background: url(${baseUrl}ImgFiles/home/bg_2.png) no-repeat center/cover;`,
      videoPlayBtn: `background: url(${baseUrl}ImgFiles/home/bof.png) no-repeat center/cover;`,
      defaultBox: `background: url(${baseUrl}ImgFiles/home/bg_1.png) no-repeat center/cover;`,
      achievementBg: `background: url(${baseUrl}ImgFiles/home/map.png) no-repeat center/cover;background-size: 100% 100%;`,
      goodPlaceBg: `background: url(${baseUrl}ImgFiles/home/youxrc.jpg) no-repeat center/cover;`,
      bottomBg: `background: url(${baseUrl}ImgFiles/home/bg_3.png) no-repeat center/cover;`,
      navList: [
        {
          url: "/Steps",
          src: require("../../assets/img/home/yingplc.png"),
          text: "应聘流程",
        },
        {
          url: "/CampusRecruiting",
          src: require("../../assets/img/home/xiaoz.png"),
          text: "校招",
        },
        {
          url: "/FAQ",
          src: require("../../assets/img/home/cjwt.png"),
          text: "答你所问",
        },
        {
          url: "/Contact",
          src: require("../../assets/img/home/lianxiwm.png"),
          text: "联系我们",
        },
      ],
      characteristicList: [
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/chuangxinjiang2-min.jpg`,
          title: "技术创新奖",
          content: "每年都有技术创新奖金，有很好的创新氛围",
        },
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/gongzuojizhi-min.jpg`,
          title: "1.5+7.5小时",
          content:
            "午休1.5小时，规定工作时间7.5小时，劳逸平衡，让人有发挥创造的精力",
        },
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/jiaoliuhui-min.jpg`,
          title: "技术交流会",
          content: "研究部、开发部经常举办的技术交流会，是技术创新的摇篮",
        },
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/jianyizhitong-min.jpg`,
          title: "建议直通",
          content:
            "每个岗位都可以通过内部网直接递交产品设计建议，好的建议就会被采纳",
        },
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/fazhanceping-min.jpg`,
          title: "职业发展测评",
          content:
            "HR每年为每个人进行职业发展健康度测评，给出最优的职业发展建议",
        },
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/xingjiyuanggong-min.jpg`,
          title: "星级员工",
          content: "员工的贡献会累计成星级，获得更好的待遇",
        },
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/PM-min.jpg`,
          title: "项目经理",
          content: "新项目会任命项目经理，产生发展机会",
        },
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/MBA.jpg`,
          title: "MBA/EMBA",
          content: "星级员工可获得进修MBA/EMBA的学费补助",
        },
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/birthday-min.jpg`,
          title: "生日假",
          content: "生日当天享受半天带薪假和一张生日蛋糕券",
        },
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/fumulvyou2-min.jpg`,
          title: "父母旅游",
          content: "星级员工的父母每年享受一次旅行费用报销",
        },
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/jiaqi2-min.jpg`,
          title: "假期",
          content: "全年享受30天以上带薪假",
        },
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/jiarenguanhuai-min.jpg`,
          title: "家人关怀",
          content:
            "星级员工每年有2个亲属体检名额，父母每年都会收到公司邮寄的节日礼品。",
        },
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/jidupeixun-min.jpg`,
          title: "季度培训",
          content: "每季度举办两次业务培训，分享产品业务、行业前沿信息",
        },
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/fenxianghui-min.jpg`,
          title: "研究分享会",
          content: "研究部定期举办分享会，互相分享个人的研究和思考",
        },
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/zhishiku-min.jpg`,
          title: "知识库",
          content: "每个部门有自己的知识库，积累了工作需要的知识和经验",
        },
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/tushuqiang-min.jpg`,
          title: "图书墙",
          content: "提供800+本免费借阅的书籍",
        },
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/huanletuanjian-min.jpg`,
          title: "欢乐团建",
          content: "每季度部门聚餐，每年海岛游、运动会、年会，尽显欢乐！",
        },
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/jieriqifen1-min.jpg`,
          title: "节日气氛",
          content: "三八妇女节、六一儿童节、感恩节、小年，都有惊喜活动",
        },
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/lingshikafei-min.jpg`,
          title: "零食咖啡",
          content: "丰盛的早餐，丰富的零食柜，现磨咖啡机，工作也可以不拘一格",
        },
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/zuijiatuandui-min.jpg`,
          title: "最佳团队",
          content: "每年评选最佳部门奖，有浓厚的团队精神和协作氛围",
        },
      ],
      doingList: [
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/wedoing2-min.jpg`,
          content: "用技术解决震荡行情",
          value: 2
        },
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/wedoing3-min.jpg`,
          content: "运用云计算和量化交易技术助力智能投顾服务",
          value: 3
        },
        {
          url: `${baseUrl}ImgFiles/home/tsjz/yz/wedoing1-min.jpg`,
          content: "深入研究多因子投资，为量化交易“赋能”",
          value: 1
        },
      ],
      dynamic: null,
      dynamicIndex: 0,
      dynamicList: [
        { text: "校招卓越人才奖金", value: 1 },
        { text: "应届毕业生住房补贴保障政策", value: 2 },
        { text: "社招安卓岗位签约可享签字费", value: 3 },
        { text: "文华苏州新研发中心楼宇建设已完工", value: 4 },
      ],

      jobList: null,
      activeId: 0,
      show: false,
      step: 0,
      netUrl: "",
      player: null,
      showVideo: false,

      list: list,

      xiaiList: [1, 2, 3, 4, 5].map(item => {
        return `${baseUrl}ImgFiles/home/xiai/${item}.png`
      }),  // 员工喜爱的文化
    };
  },
  computed: {
    achievementList() {
      let data = this.$store.state.commonData;
      return [
        {
          num: data.countSecurity,
          unit: "家",
          type: "证券公司",
        },
        {
          num: data.countFutures,
          unit: "家",
          type: "期货公司",
        },
        {
          num: data.countInvestment,
          unit: "家",
          type: "投资机构",
        },
        {
          num: data.countInvestor,
          unit: "多万",
          type: "期货投资者",
        },
      ]      
    },
  },
  mounted() {
    this.player = new Aliplayer({
      id: "player-con",
      source: "//wenhua-assets.oss-cn-beijing.aliyuncs.com/wenhua/OtherProject/web/2022-10/hr3.mp4",
      width: "100%",
      height: "100%",
      useH5Prism: true,
      // playsinline: false,
      // x5_type: "h5",
      // videoHeight: "100%",
      cover: `${baseUrl}ImgFiles/home/bg_2.png`,
      /* To set an album art, you must set 'autoplay' and 'preload' to 'false' */
      autoplay: false,
      preload: false,
      isLive: false,
      "skinLayout": [
          // {
          // "name": "bigPlayButton",
          // "align": "blabs",
          // "x": 30,
          // "y": 80
          // },
          {
          "name": "H5Loading",
          "align": "cc"
          },
          {
          "name": "errorDisplay",
          "align": "tlabs",
          "x": 0,
          "y": 0
          },
          {
          "name": "infoDisplay"
          },
          {
          "name": "tooltip",
          "align": "blabs",
          "x": 0,
          "y": 56
          },
          {
          "name": "thumbnail"
          },
          {
          "name": "controlBar",
          "align": "blabs",
          "x": 0,
          "y": 0,
          "children": [
              {
              "name": "progress",
              "align": "blabs",
              "x": 0,
              "y": 44
              },
              {
              "name": "playButton",
              "align": "tl",
              "x": 15,
              "y": 12
              },
              {
              "name": "timeDisplay",
              "align": "tl",
              "x": 10,
              "y": 7
              },
              {
              "name": "fullScreenButton",
              "align": "tr",
              "x": 10,
              "y": 12
              },
              {
              "name": "setting",
              "align": "tr",
              "x": 15,
              "y": 12
              },
              {
              "name": "volume",
              "align": "tr",
              "x": 5,
              "y": 10
              }
          ]
        }
      ]
    }, (player)=>{
      player.on('ended', ()=>{return this.stop();});
      console.log("The player is created");
    });

    let characteristic = new Swiper(".characteristic-swiper-container", {
        loop: true,
        spaceBetween: -60,
        slidesPerView: "auto",
        centeredSlides: true,
        slideToClickedSlide: true,
        initialSlide: 1,
        loopedSlides: this.characteristicList.length,
        roundLengths: true,
        autoplay: 1500,
        speed: 1000,
        autoplayDisableOnInteraction: false,
      }),

      xiai = new Swiper("#xiai", {
        spaceBetween: 10,
        slidesPerView: "auto",
        slideToClickedSlide: true,
        initialSlide: 0,
        slidesOffsetBefore : 10,
        slidesOffsetAfter : 10,
      }),
      
      tiyan = new Swiper("#tiyan", {
        spaceBetween: 10,
        slidesPerView: "auto",
        slideToClickedSlide: true,
        initialSlide: 0,
        slidesOffsetBefore : 10,
        slidesOffsetAfter : 10,
      }),
      wedDoingSwiper = new Swiper(".wed-doing-container", {
        spaceBetween: 15,
        slidesPerView: "auto",
        slideToClickedSlide: true,
        initialSlide: 0,
        slidesOffsetBefore : 15,
        slidesOffsetAfter : 15,
      });
    xiai.update();
    characteristic.update();
    tiyan.update();
    wedDoingSwiper.update();

    characteristic.on('tap', (swiper)=>{
      this.$router.push("/Feature");
    })
    wedDoingSwiper.on('tap', (swiper)=>{
      this.$router.push("/Doing/"+swiper.clickedSlide.attributes['val'].value);
    })

    let index = 0;
    this.dynamic = setInterval(() => {
      index++;
      if (index >= this.dynamicList.length) {
        index = 0;
      }
      this.dynamicIndex = index;
    }, 5000);

  },
  created() {
    // 获取工作列表
    this.$http.post("/api/dataapi/job?whid=wenhua").then((res) => {
      if (res.status != 200 || !res.data) return;
      this.jobList = res.data;
    });
  },
  methods: {
    play() {
      this.showVideo = true;
      // 自动播放
      this.player.play();
    },
    stop() {
      this.showVideo = false;
      // this.player.ended();
    },
    applyJob() {
      this.$http.post("/User/IsLogin").then((res) => {
        if (res.status != 200 || !res.data) return;
        let isLogin = res.data;

        if (isLogin.status) {
          // this.netUrl = isLogin.data.url;
          // if (isLogin.data.status == 1) {
          //   this.showDialog(2);
          // } else if (isLogin.data.status == 0) {
          //   // 未填写基本信息
          //   this.showDialog(1);
          // }
          window.location.href = "/Job/FullTest";
          this.closeDialog();
        } else {
          // 未登录
          this.showDialog(0);
        }
      });
    },
    closeDialog() {
      this.show = false;
    },
    showDialog(step) {
      this.step = step;
      this.show = true;
    },
    playerPause() {
      this.showVideo = false;
      this.player.pause();
    },
  },
  beforeDestroy() {
    clearInterval(this.dynamic);
    this.dynamic = null;
  },
  watch: {
    $route(to, from) {
      if (to.name != 'home') {
        this.playerPause();
      }
    },
    show(val) {
      if (val) {
        this.playerPause();
      }
    }
  }
};
</script>

<style scoped>
.page-wrap {
  width: 100%;
  position: absolute;
  bottom: 0;
  /* overflow-x: hidden; */
  overflow-y: auto;
  left: 0;
  right: 0;
}
.video-wrap {
  height: 11.443rem;
  width: 100%;
  position: relative;
  overflow: hidden;
}
.video-bg {
  width: 100%;
  height: 100%;
}
#player-con {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.video-text-wrap {
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
}
.video-text {
  font-size: 1.6rem;
  font-weight: bold;
  color: #fff;
}
.video-play-btn {
  margin: 0.552rem auto 0;
  height: 1.72rem;
  width: 1.725rem;
  cursor: pointer;
}
.prism-big-play-btn.pause {
  display: none!important;
  left: 50%;
}
.prism-player .prism-big-play-btn {
  width: 45px;
  height: 45px;
  background-size: 128px 256px;
  display: none!important;
}
.dynamic-wrap {
  width: 100%;
  margin: 0 auto;
  padding: 0.6rem 0.73rem;
  overflow: hidden;
  font-size: 0.53rem;
  box-sizing: border-box;
}
.dynamic-title {
  display: inline-block;
  font-weight: 600;
  position: relative;
  padding: 0 0 0 10px;
  color: #393939;
}
.dynamic-title::before {
  content: " ";
  display: block;
  position: absolute;
  left: 0;
  width: 0.1rem;
  height: 100%;
  background: rgb(243, 160, 19);
}
.dynamic-content {
  display: inline-block;
  color: #797979;
  /* transition: 0.3s; */
}
.dynamic-list-enter-active,
.dynamic-list-leave-active {
  transition: opacity 0.5s;
}
.dynamic-list-enter,
.dynamic-list-leave-to {
  opacity: 0;
}
.dynamic-content .dynamic-more {
  text-decoration: underline;
  color: #4087ec;
  cursor: pointer;
}
.nav-wrap {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  width: 100%;
  height: 5.67rem;
  box-sizing: border-box;
}
.nav-item {
  margin-top: 1.2rem;
  /* width: 2.866rem; */
  display: flex;
  flex-direction: column;
  text-align: center;
}
.nav-img {
  object-fit: cover;
  width: 1.18rem;
  height: 1.18rem;
}
.nav-text {
  font-size: 0.65rem;
  color: #1d2c66;
  font-weight: 600;
}
.disc-swiper-slide,
.wed-doing-slide {
  width: 85%;
  /* margin-right: 0.7rem; */
}

.disc {
  margin-top: 1rem;
}
.disc-box::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  box-shadow: 0 0 18px 22px rgb(255 255 255);
}
.disc-img {
  height: 12.264rem;
  width: 100%;
}
.disc-text {
  height: 6.8rem;
  width: 94%;
  background-color: #f4f4f4;
  margin: 0 auto;
  font-size: 0.68rem;
  padding: 1rem 0.526rem 0.795rem;
  color: #595959;
  margin-top: -2.386rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.disc-text .content {
  line-height: 1.5;
  flex: auto;
}
.disc-text strong {
  font-weight: bold;
  font-size: 0.831rem;
  color: #492717;
}
.disc-text .signature {
  text-align: right;
}
.gap {
  margin-top: 2rem;
}
.characteristic-wrap {
  height: 13rem;
  width: 100%;
  position: relative;
}
/* 背景图 */
.default-box {
  position: absolute;
  width: 100%;
  height: 10.674rem;
}
.characteristic-swiper-container {
  height: 100%;
  box-sizing: border-box;
}
.characteristic-swiper {
  align-items: flex-end;
}
.characteristic-swiper-slide {
  text-align: left;
  background: #fff;
  color: #ffffff;

  transition: all 500ms;

  width: 12.57rem;
  height: 75%;
  position: relative;
  bottom: 10%;

  display: flex;
  flex-direction: column;

  transform: translateZ(0px) scale(0.8) !important;
  -webkit-transform: translateZ(0px) scale(0.8) !important;
}

.characteristic-swiper-slide.swiper-slide-active,
.characteristic-swiper-slide.swiper-slide-duplicate-active {
  height: 11rem;
  bottom: 0;
  transform: translateZ(0px) scale(1) !important;
  -webkit-transform: translateZ(0px) scale(1) !important;
  z-index: 3;
}
/* 轮播图片 */
.characteristic-img {
  flex: auto;
  background-size: cover !important;
  background-position: center !important;
  user-select: none;
}
.characteristic-box {
  width: 100%;
  height: 0;
  box-sizing: border-box;
  position: relative;
  background: rgba(242, 157, 7, 1);
  transition: 500ms;
  transform: translateZ(0px);
}
.characteristic-swiper-slide.swiper-slide-active .characteristic-box,
.characteristic-swiper-slide.swiper-slide-duplicate-active .characteristic-box {
  height: 35%;
  padding: 0.4rem;
  transform: translateZ(0px);
}
.characteristic-swiper-slide .c-title {
  font-size: 0.7rem;
  font-weight: 600;
  visibility: hidden;
}
.characteristic-swiper-slide .c-banner {
  font-size: 0.6rem;
  font-weight: 500;
  margin-top: 0.3rem;
  visibility: hidden;
}
.characteristic-swiper-slide.swiper-slide-active .c-title,
.characteristic-swiper-slide.swiper-slide-duplicate-active .c-title,
.characteristic-swiper-slide.swiper-slide-active .c-banner,
.characteristic-swiper-slide.swiper-slide-duplicate-active .c-banner {
  visibility: visible;
}

.title-wrap {
  padding-left: 0.654rem;
  box-sizing: border-box;
  margin-bottom: 0.924rem;
}
.item-title {
  font-size: 0.808rem;
  color: rgb(62, 64, 94);
  font-weight: 600;
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.item-title::after {
  content: "";
  display: block;
  height: 4px;
  width: 100%;
  border-radius: 4px;
  position: absolute;
  bottom: -4px;
  left: 0;
  background: linear-gradient(to right, #0bbafb, #4087ec);
}
.we-doing-bg {
  height: 13rem;
}
.we-doing-text {
  height: 4.477rem;
  box-sizing: border-box;
  padding: 0.334rem 0.59rem 0.744rem 0.718rem;
  background-color: #f7f7f7;
  font-size: 0.75rem;
  display: flex;
  flex-direction: column;
}
.we-doing-text > div:first-child {
  color: #6a6a6a;
  flex: auto;
  font-weight: 600;
}
.we-doing-text > div:last-child {
  text-align: right;
  color: #547ad6;
  text-decoration: underline;
  user-select: none;
}
.concept {
  padding: 0 0.988rem;
  color: #585858;
  font-size: 0.65rem;
}
.concept > div {
  text-indent: 2em;
  line-height: 2;
}
.concept > .name {
  text-align: right;
  margin-top: 1.013rem;
}
.achievement {
  /* background-size: 100% 100%; */
  height: 11.468rem;
  box-sizing: border-box;
  color: rgb(65, 75, 84);
  padding-top: 1.49rem;
  /* margin-top: 2rem; */
}

.achievement > .data-detail {
  text-align: center;
  display: flex;
  justify-content: space-evenly;
  /* height: 1.462rem; */
  position: relative;
  margin-top: 2rem;
}
.good-place {
  height: 9.468rem;
  box-sizing: border-box;
  color: rgb(65, 75, 84);
  line-height: 1.5;
  padding-top: 0.6rem;
}
.good-place p {
  text-indent: 2em;
}
.good-place p:first-child {
  font-weight: bold;
}
.bottom-bg {
  height: 9.468rem;
  box-sizing: border-box;
  color: rgb(65, 75, 84);
  /* margin-top: -3.8rem; */
}
.data {
  /* width: 3.6rem;
  height: 100%; */
  font-size: 0.58rem;
  color: #7f7f7f;
}

.data > .numeric > span:first-child {
  font-size: 1.2rem;
  color: #5a5a5a;
  font-weight: bold;
}
/* 工作体验 */

#tiyan {
  box-sizing: border-box;
}

#tiyan::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    box-shadow: 0 0 10px 7px rgba(255, 255, 255, .1);
    -webkit-box-shadow: 0 0 10px 7px rgba(255, 255, 255, .1);
    z-index: 9;
    -webkit-appearance: none;
}

.tiyan_item {
  width: 83%;
}
.tiyan_item_header {
  display: flex;
  align-items: center;
  margin-bottom: -0.55rem;
  padding-left: 0.6rem;
}
.tiyan_icon {
  width: 2rem;
  height: 2rem;
  z-index: 3;
}
.tiyan_name {
  font-size: 0.65rem;
  line-height: 100%;
  font-weight: bold;
  margin-left: 0.2rem;
  color: #808080;
}
.tiyan_content {
  width: 100%;
}
.tiyan_content > img {
  width: 100%;
}
</style>